import { gql } from '@apollo/client';

export const INTEGRATION_META_TYPE_FIELDS = gql`
    fragment IntegrationMetaTypeFields on integration_meta_types {
        integration_type_id
        name
        marketplace_tier
        client_id
    }
`;
